// <photo-gallery-2cv>: used by sections/photo-gallery-2cv.liquid and
// sections/car-details-2cv.liquid (each car's page), which load this file.
// It's an asset rather than a {% javascript %} tag because Shopify only runs
// a section's bundled JS on pages where that section is rendered. Guarded,
// so loading it twice is harmless.
//
// Shows one photo at a time: arrows (and the left/right arrow keys) step
// through them, thumbnails jump straight to one. In the theme editor,
// selecting a photo block switches to it too.
if (!customElements.get('photo-gallery-2cv')) {
  customElements.define(
    'photo-gallery-2cv',
    class PhotoGallery2cv extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
        this.thumbStrip = this.querySelector('[data-gallery-thumbs]');
        this.counter = this.querySelector('[data-gallery-counter]');
        this.caption = this.querySelector('[data-gallery-caption]');
        this.index = 0;

        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      onClick(event) {
        const button = event.target.closest('[data-gallery-prev], [data-gallery-next], [data-gallery-thumb]');
        if (!button) return;

        if (button.hasAttribute('data-gallery-prev')) this.show(this.index - 1);
        else if (button.hasAttribute('data-gallery-next')) this.show(this.index + 1);
        else this.show(Number(button.dataset.galleryThumb));
      }

      onKeydown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (!event.target.closest('.gallery-2cv__carousel') || this.slides.length < 2) return;

        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
        // Keep focus on the current thumbnail when stepping through them.
        if (event.target.hasAttribute('data-gallery-thumb')) this.thumbs[this.index].focus();
      }

      onBlockSelect(event) {
        const slide = event.target.closest('[data-gallery-slide]');
        if (slide) this.show(this.slides.indexOf(slide));
      }

      show(index) {
        const count = this.slides.length;
        if (count === 0) return;

        this.index = (index + count) % count;
        this.slides.forEach((slide, i) => {
          slide.hidden = i !== this.index;
        });
        this.thumbs.forEach((thumb, i) => {
          thumb.setAttribute('aria-current', i === this.index ? 'true' : 'false');
        });
        if (this.counter) this.counter.textContent = `${this.index + 1} / ${count}`;
        if (this.caption) this.caption.textContent = this.slides[this.index].dataset.caption || '';
        this.revealThumb(this.thumbs[this.index]);
      }

      // Scrolls only the thumbnail strip (not the page) to bring the current
      // thumbnail into view.
      revealThumb(thumb) {
        if (!thumb || !this.thumbStrip) return;

        const strip = this.thumbStrip;
        const start = thumb.offsetLeft;
        const end = start + thumb.offsetWidth;
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

        if (start < strip.scrollLeft) {
          strip.scrollTo({ left: start, behavior });
        } else if (end > strip.scrollLeft + strip.clientWidth) {
          strip.scrollTo({ left: end - strip.clientWidth, behavior });
        }
      }
    }
  );
}
